import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';
import { NxMessageToastService } from "@aposin/ng-aquila/message";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: "app-forgotpassword",
  templateUrl: "./forgotpassword.component.html",
  styleUrls: ["./forgotpassword.component.css"],
})
export class ForgotpasswordComponent implements OnInit {
  forgotPwdForm: FormGroup;
  _apiUrl: string;
  firstlogin: number;
  GCaptcha: string;
  GCaptchaSecret: string;
  Gsize: string = "invisible";
  @ViewChild("captchaRef") reCaptcha;
  constructor(
    private authService: AuthService,
    private appConfig : AppConfig,
    private messageToastService: NxMessageToastService,
    private router: ActivatedRoute,
    private route: Router
  ) {
    this.GCaptcha = appConfig.gCaptchaKey;
    this.GCaptchaSecret = appConfig.gCaptchaSecret;
    this._apiUrl = appConfig.baseUrl;
    this.forgotPwdForm = new FormBuilder().group({
      emailId: ["", Validators.required],
      clientId: parseInt(atob(localStorage.getItem("CLIENT_ID"))),
      captcha: new FormGroup({
        secret: new FormControl(this.GCaptchaSecret, Validators.required),
        response: new FormControl(""),
        remoteip: new FormControl(""),
      }),
    });
  }

  ngOnInit() {}

  forgotPassword() {
    this.authService.post(this._apiUrl + '/api/v1/Password/forgotPassword', this.forgotPwdForm.value).subscribe(response => {
      if (response) {
        if (response.success) {
          this.messageToastService.open(response.responsemsg, { context: 'info', duration: 5000 });
          localStorage.setItem("ISFIRSTLOGIN", "0");
          this.firstlogin = 0;
          this.route.navigate(['']);
        }
        else {
          this.messageToastService.open(response.responsemsg, { context: 'info', duration: 5000 });
        }
      }
    }, (error) => {
      this.reCaptcha.reset();
      console.error(error);
    });
  }

  public submit(captchaResponse: string): void {
    if (captchaResponse !== null) {
      this.forgotPwdForm.patchValue({
        captcha: {
          response: captchaResponse,
        },
      });
      this.forgotPassword();
    }
  }
}
